import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '../../node_modules/reactstrap/esm/Card.js';
import { lightgrey } from '../../assets/colors.js';

var _templateObject, _templateObject2;
var ProfileDataBoxDefinition = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-basis: 50%;\n  padding: 30px;\n  flex-direction: column;\n  justify-content: space-between;\n  @media (min-width: 768px) and (max-width: 991.98px) {\n    ", "\n  }\n"])), function (_ref) {
  var square = _ref.square;
  return square && "flex-basis: 75%";
});
ProfileDataBoxDefinition.displayName = "ProfileDataBox";
var ProfileDataBox = ProfileDataBoxDefinition;
var ProfileWidgetBoxDefinition = styled(Card)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  border: none;\n  border-radius: none;\n  ", "\n  background: ", ";\n"])), function (props) {
  return props.vertical && "column" || "row";
}, function (_ref2) {
  var fluid = _ref2.fluid,
    vertical = _ref2.vertical;
  return fluid ? "width: 100%;" : vertical && "max-width: 306px;";
}, lightgrey);
ProfileWidgetBoxDefinition.displayName = "ProfileWidgetBox";
ProfileWidgetBoxDefinition.propTypes = {
  vertical: PropTypes.bool,
  fluid: PropTypes.bool
};
var ProfileWidgetBox = ProfileWidgetBoxDefinition;

export { ProfileDataBox, ProfileWidgetBox };
